var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetLogoLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 211,
    viewBox: "0 0 209 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7566 64.3628L71.5872 24.5511L126.126 30.4009L27.6762 119.824L27.7566 64.3628Z",
    fill: "#48AAF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4023 67.4375L74.5036 33.7381L120.252 38.2299L36.9166 113.924L37.4023 67.4375Z",
    fill: "#48AAF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.144 167.16L27.7329 119.773L126.183 30.3493L158.144 167.16Z",
    fill: "#1778FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.543 153.393L45.1271 116.541L121.688 47L146.543 153.393Z",
    fill: "#1778FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetLogoLoad);
export default __webpack_public_path__ + "static/media/asset_logo_load.33b138d3855fee1730c3a0a753b0342f.svg";
export { ForwardRef as ReactComponent };